/**
 * Function to resolve a link in WP content
 *
 * IMPORTANT:
 * Expected Settings in WP > Settings > Permalinks
 * - Custom Structure: /posts/%postname%/
**/

import { isRelLink, isExtLink } from '@/utils'

export default function (href) {
  let base = process.env.BASE_URL || ''
  base = base.replace(/\/$/g, '') // remove ending /
  // relative
  if (isRelLink(href) || isExtLink(href)) return href
  const url = new URL(href)
  // home ?
  if (url.pathname === '/') return base + '/'
  // parse path
  else {
    let path = url.pathname + url.search
    path = path.split('/')
    // home ?
    if (path[1] === 'home') return base + '/'
    // campaigns (collection)
    // if (path[1] === 'collection') return base + path.join('/').replace('collection', 'campaigns')
    // shop
    if (path[1] === 'shop') return base + path.join('/').replace('shop', 'collections')
    // default (page)
    return base + path.join('/')
  }
}
